import { ValueDisplayWithLabel } from '../../components/ValueDisplay';
import { TWeatherForecast } from './types';
import { themedUseStyletron } from '../../../theme/customTheme';
import { OperatorPanelWrapperFullSize } from '../../components/Layout';
import { getDimension, getForecast, isWrongConfig } from './utils';
import { FormattedMessage, } from 'react-intl';
import Forecast from './Forecast';
import { HorizontalStackPanel } from '../../../components/Layout/StackPanel';
import WrongConfig from './WrongConfig';
import ForecastEmptyState from './ForecastEmptyState';

export const OperatorPanel = (props: TWeatherForecast) => {
    const [css, theme] = themedUseStyletron();
    const forecast = getForecast(props);
    const dim = getDimension(props.units);
    const wrongConfig = isWrongConfig(props);
    
    return (

        <OperatorPanelWrapperFullSize
            objectId={props.id}
            resourceGroupId={props.resourceGroupId}
            statusContent={
                <>
                    {wrongConfig && <WrongConfig {...props}/>}
                    {!forecast && !wrongConfig && <ForecastEmptyState {...props} />}
                    {forecast &&
                        <>
                            <HorizontalStackPanel $alignItems={'flex-end'}>
                                <ValueDisplayWithLabel value={props.temp} label={<FormattedMessage id="SubPlants.Temperature" defaultMessage="Temperature" />} dimension={dim} ></ValueDisplayWithLabel>
                                {forecast.current.iconUrl && <div className={css({ width: theme.sizing.scale1000, height: theme.sizing.scale1000, borderRadius: '50%', background: 'white' })}>
                                    <img alt='icon' src={`https://openweathermap.org/img/wn/${forecast.current.iconUrl}@2x.png`} className={css({ width: '100%' })} />
                                </div>}
                            </HorizontalStackPanel>
                            <Forecast {...props}></Forecast>

                            <HorizontalStackPanel $gap={theme.sizing.scale400}>
                                <ValueDisplayWithLabel mini value={props.tempNextDayMin} label={<FormattedMessage id='Utils.WeatherForecast.Min' defaultMessage="Min. Temperature" />} dimension={dim} ></ValueDisplayWithLabel>
                                <ValueDisplayWithLabel mini value={props.tempNextDayMax} label={<FormattedMessage id='Utils.WeatherForecast.Max' defaultMessage="Max. Temperature" />} dimension={dim} ></ValueDisplayWithLabel>
                            </HorizontalStackPanel>
                        </>
                    }

                </>
            }
        >
        </OperatorPanelWrapperFullSize>



    )
}
